// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__1B_WP"};